import { collectedDataStepsTitle, CollectedDataStepType } from '../constants/collectedData'
import { CollectDataTemplateStep } from '../interfaces/collectDataTemplateStep'
import { replaceTrainingWording } from './certificationWording'

export const getCollectDataTemplateStepTitle = (
  collectDataStep: CollectDataTemplateStep,
): string => {
  let title = collectedDataStepsTitle[collectDataStep.type]

  if (collectDataStep.type === CollectedDataStepType.Form && collectDataStep?.label) {
    title = collectDataStep.label
  }

  if (
    collectDataStep.type === CollectedDataStepType.SignContract &&
    collectDataStep?.label !== CollectedDataStepType.SignContract
  ) {
    title = `${title} - ${collectDataStep.label}`
  }

  if (
    collectDataStep.type === CollectedDataStepType.InsuranceCoverage &&
    collectDataStep.metadata &&
    'insurancePolicyProduct' in collectDataStep.metadata
  ) {
    const productName = collectDataStep.metadata.insurancePolicyProduct?.insuranceProduct?.name

    if (productName) {
      title = `${title} - ${productName}`
    }
  }

  if (
    collectDataStep.type === CollectedDataStepType.VehicleAndInsurance &&
    collectDataStep.metadata &&
    'disableInsuranceUpload' in collectDataStep.metadata &&
    collectDataStep.metadata?.disableInsuranceUpload
  ) {
    title = 'Vehicle Information'
  }

  return replaceTrainingWording(title)
}
